/**
 * Public Vendor Form container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Actions from './actions';
import VendorAttributionForm from '../../Components/VendorAttribution/VendorAttributionForm';
import { vendorAttributesErrorSelector } from './selectors';

const mapDispatchToProps = (dispatch) => ({
  createVendorAttributes: (attributes) =>
    dispatch(Actions.createVendorAttributes(attributes)),
  updateVendorAttributes: (userId, update) =>
    dispatch(Actions.updateVendorAttributes(userId, update)),
});

const mapStateToProps = (state) => ({
  error: vendorAttributesErrorSelector(state),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorAttributionForm),
);
